/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import BarChart, { parseBarChartConfig } from "./BarChart";

const AutomationsBarChart = ({data, scope}) => {
  // check data exists
  const chartConfig = parseBarChartConfig(data, scope);
  const dataKeys = [
    { name: "Sent", key: "sent", color: "#7c5af5" },
    { name: "Opened", key: "opened", color: "#1ba1a8" },
    { name: "Clicked", key: "clicked", color: "#349425"  }
  ];

  return chartConfig ? (
    <BarChart
      title="Marketing Trends"
      subtitle={chartConfig.name}
      type="line"
      data={chartConfig.data}
      dataKeys={dataKeys}
      dataColors={dataKeys.map(key => key.color)}
    />
  ) : null;
};

export default AutomationsBarChart;